import { Text, TextProps, Tooltip } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";

export const NodeLabel: React.FC<{ label: string } & TextProps> = ({
  label,
  noOfLines = 3,
  ...textProps
}) => {
  const containerRef = useRef<HTMLParagraphElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      setIsOverflowing(
        containerRef.current.scrollHeight > containerRef.current.clientHeight,
      );
    }
  }, [label]);

  const text = (
    <Text ref={containerRef} noOfLines={noOfLines} width="80%" {...textProps}>
      {label}
    </Text>
  );
  return isOverflowing ? <Tooltip label={label}>{text}</Tooltip> : text;
};
